import { useEffect, useState } from 'react';

import Search from "../../Search/Search";
import ClosePopUpButton from "../../ClosePopUpButton/ClosePopUpButton";
import { useContextValue } from "../../../context/context";
import { GeoIcon } from "../../../assets/cardIcons";
import './style.css';

//?`Temporary data
const streetOptions = ["Polostraße", "Potosistraße", "Prahlstraße", "Präsident-Krahn-Straße", "Lindestrasse", "Lindenstraße", "Lindwurmstraße", "Lipowskystraße", "Lohengrinstraße", "Lohstraße", "Lortzingstraße", "Ludwigstraße", "Luisenstraße", "Luitpoldstraße", "Lustheimstraße", "Lustspielhausstraße", "Lutherstraße", "Lützowstraße", "Lyonel-Feininger-Straße", "Maaßenstraße", "Machnower Straße", "Maderstraße", "Maffeistraße", "Magdalenenstraße", "Maienstraße", "Maillingerstraße", "Mainaustraße", "Mainzer Straße", "Makartstraße", "Malerstraße", "Mallersdorfer Straße", "Mallwitzstraße", "Malschstraße", "Mamistraße", "Mangfallstraße", "Mangoldstraße", "Mannertstraße", "Mannheimer Straße", "Manteuffelstraße", "Manzostraße", "Marbachstraße", "Marcel-Breuer-Straße", "Marchstraße", "Margaretenstraße", "Maria-Eich-Straße", "Maria-Theresia-Straße", "Mariannenstraße", "Marienplatz", "Marienstraße", "Marienweg", "Marienthaler Straße", "Marinestraße", "Markgrafenstraße", "Marktstraße", "Markusstraße", "Marlachstraße", "Marlstraße", "Marstallstraße", "Marthastraße", "Martin-Luther-Straße", "Martin-Mayr-Straße", "Martinistraße", "Martiusstraße", "Marxstraße", "Marzlingstraße", "Masch"];


const PlacePopUp = ({ onClose }) => {
	const [validation, setValidation] = useState(false);
	const [adressData, setAdressData] = useState({
		postIndex: "",
		street: "",
		building: "",
		apartment: ""
	});
	const { setPlace, filledCards, setFilledCards } = useContextValue();

	useEffect(() => {
		const allFieldsFilled = Object.values(adressData).every((value) => value.trim() !== "");

		if (allFieldsFilled) {
			setValidation(true);
		}
	}, [adressData]);

	const filteredItems = streetOptions.filter((street) =>
		street.toLowerCase().includes(adressData.street.toLowerCase())
	);

	const handleSearch = (text) => {
		setAdressData((prev) => ({
			...prev,
			street: text,
		}));
	}

	const handleStreetSelection = (street) => {
		setAdressData((prev) => ({
			...prev,
			street,
		}));
	};

	const handleSubmit = () => {
		if (validation) {
			setPlace(adressData);
		}

		const newCard = {
			content: `${adressData.postIndex} ${adressData.street} ${adressData.building} ${adressData.apartment}`,
			isSelected: true,
			title: "Einsatzort",
			backgroundColor: "#A23A39",
			icon: GeoIcon
		};
		const existingCardIndex = filledCards.findIndex(card => card.title === newCard.title);

		if (existingCardIndex !== -1) {
			const updatedCards = [...filledCards];
			updatedCards[existingCardIndex] = newCard;
			setFilledCards(updatedCards);
		} else {
			setFilledCards([...filledCards, newCard]);
		}

		onClose();
	};

	return (
		<div className="place-popup">
			<Search text="Suchen" width="100%" backgroundColor="white" />
			<div className="place-popup-content">
				<div className="place-popup-columns">
					<div className="row">
						<div className="cell">Postleitzahl</div>
						<div className="cell">
							<input onChange={(e) =>
								setAdressData((prev) => ({
									...prev,
									postIndex: e.target.value,
								}))
							} type="number" />
						</div>
					</div>
					<div className="row">
						<div className="cell">Straße</div>
						<div className="cell">
							<div className="place-popup-street">
								<input
									type="text"
									value={adressData.street}
									placeholder="Suche nach einer Straße"
									onChange={(e) => handleSearch(e.target.value)} />
								<ul className="place-popup-street_options">
									{filteredItems.length > 0 ? (
										filteredItems.map((street, index) => (
											<li
												key={index}
												onClick={() => handleStreetSelection(street)}
												className="place-popup-street_option"
											>
												{street}
											</li>
										))
									) : (
										<li className="no-results">Keine Ergebnisse gefunden</li>
									)}
								</ul>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="cell">Hausnummer</div>
						<div className="cell">
							<input onChange={(e) =>
								setAdressData((prev) => ({
									...prev,
									building: e.target.value,
								}))
							}
								type="text" />
						</div>
					</div>
					<div className="row">
						<div className="cell">Zusatz</div>
						<div className="cell">
							<input onChange={(e) =>
								setAdressData((prev) => ({
									...prev,
									apartment: e.target.value,
								}))
							}
								type="text" />
						</div>
					</div>
				</div>
			</div>
			{
				validation ?
					<button className="place-popup-request" onClick={handleSubmit}>AUSWAHL BESTÄTIGEN</button>
					:
					<p style={{ color: "red", textAlign: "center", margin: "10px 0" }}>Alle Felder müssen ausgefüllt werden</p>
			}
			<ClosePopUpButton onClose={onClose} />
		</div>
	)
}

export default PlacePopUp;
